export const statusIndicator = {
  0: 'Ativa',
  1: 'Inativa 1',
  2: 'Inativa 2',
  3: 'Inativa 3',
  4: 'Inativa 4',
  5: 'Inativa 5',
  6: 'Inativa 6'
};
